/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

export type SmsBatchSummaryStatus =
  (typeof SmsBatchSummaryStatus)[keyof typeof SmsBatchSummaryStatus]

export const SmsBatchSummaryStatus = {
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  PARTIALLY_COMPLETED: "PARTIALLY_COMPLETED",
  FAILED: "FAILED",
} as const
